import { RESET, OPEN_TAB, ETab, ISidebarState, SET_VISIBLE, SET_HEADER_VISIBLE } from 'store/sidebar/types';

const initialState: ISidebarState = {
  activeTab: ETab.DEFAULT,
  visible: false,
  displayNavHeader: false,
};

export interface IActionInterface {
  type: string;
  tab: ETab.DEFAULT;
  visible: boolean;
  displayNavHeader: boolean;
}

export default (state = initialState, action: IActionInterface) => {
  switch (action.type) {
    case RESET: {
      return initialState;
    }

    case OPEN_TAB: {
      return {
        ...state,
        activeTab: action.tab,
      };
    }

    case SET_VISIBLE: {
      return {
        ...state,
        visible: action.visible,
      };
    }

    case SET_HEADER_VISIBLE: {
      return {
        ...state,
        displayNavHeader: action.displayNavHeader,
      };
    }

    default: {
      return state;
    }
  }
};
